// extracted by mini-css-extract-plugin
export default {"block":"foother_block__A6vnM","table":"foother_table__X4Mla","tableLi":"foother_tableLi__qmkc7","text":"foother_text__8b4i9","c":"foother_c__qiCaZ"};